import { render, staticRenderFns } from "./OrganizationResponsibilitiesTab.vue?vue&type=template&id=40d1396d&scoped=true"
import script from "./OrganizationResponsibilitiesTab.vue?vue&type=script&lang=js"
export * from "./OrganizationResponsibilitiesTab.vue?vue&type=script&lang=js"
import style0 from "./OrganizationResponsibilitiesTab.vue?vue&type=style&index=0&id=40d1396d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1396d",
  null
  
)

export default component.exports